import { render, staticRenderFns } from "./FertilizationCropSelector.vue?vue&type=template&id=4b714140&scoped=true&"
import script from "./FertilizationCropSelector.vue?vue&type=script&lang=js&"
export * from "./FertilizationCropSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b714140",
  null
  
)

export default component.exports